function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var _require = require('./canonical-receipt'),
  resolveCanonicalCallback = _require.resolveCanonicalCallback,
  resolveCanonicalReceipt = _require.resolveCanonicalReceipt;
var runStorage = require('./run-storage');
var PAGE_SIZE = 100;
var MAX_RECONCILIATION_CANDIDATES = 5000;
var CONFIRMED_MISMATCH_REASONS = new Set(['noncanonical', 'transaction_missing']);
function associatedProof(proof) {
  return Object.freeze({
    entry: proof.entry,
    verification: proof.verification,
    chain: Object.freeze({
      state: 'associated',
      walletPublicKey: proof.chain.walletPublicKey,
      transactionSignature: proof.chain.transactionSignature,
      associatedAt: proof.chain.associatedAt,
      block: null
    })
  });
}
function observedProof(proof, resolution, observedAt) {
  return Object.freeze({
    entry: proof.entry,
    verification: proof.verification,
    chain: Object.freeze({
      state: 'observed',
      walletPublicKey: proof.chain.walletPublicKey,
      transactionSignature: proof.chain.transactionSignature,
      associatedAt: proof.chain.associatedAt,
      block: Object.freeze({
        id: resolution.blockId,
        hash: resolution.blockHash,
        observedAt: observedAt
      })
    })
  });
}
function receipt(proof, confirmations, reason, action) {
  return Object.freeze({
    proof: proof,
    confirmations: confirmations,
    reason: reason,
    action: action
  });
}
function resolveStoredReceipt(_x, _x2, _x3, _x4, _x5) {
  return _resolveStoredReceipt.apply(this, arguments);
}
function _resolveStoredReceipt() {
  _resolveStoredReceipt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(storage, dbname, blockchain, fingerprint, observedAt) {
    var attempt,
      proof,
      candidate,
      resolution,
      replaced,
      cleared,
      _args = arguments,
      _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          attempt = _args.length > 5 && _args[5] !== undefined ? _args[5] : 0;
          _context.n = 1;
          return runStorage.returnRunProof(storage, dbname, fingerprint);
        case 1:
          proof = _context.v;
          if (proof) {
            _context.n = 2;
            break;
          }
          return _context.a(2, null);
        case 2:
          if (!(proof.chain.state !== 'observed')) {
            _context.n = 3;
            break;
          }
          return _context.a(2, receipt(proof, 0, proof.chain.state, 'unchanged'));
        case 3:
          candidate = {
            fingerprint: fingerprint,
            transactionSignature: proof.chain.transactionSignature,
            blockId: proof.chain.block.id,
            blockHash: proof.chain.block.hash
          };
          _context.p = 4;
          _context.n = 5;
          return resolveCanonicalReceipt(blockchain, candidate);
        case 5:
          resolution = _context.v;
          _context.n = 7;
          break;
        case 6:
          _context.p = 6;
          _t = _context.v;
          return _context.a(2, receipt(associatedProof(proof), 0, 'chain_unavailable', 'deferred'));
        case 7:
          if (!(resolution.state === 'observed')) {
            _context.n = 12;
            break;
          }
          if (!(resolution.blockId === candidate.blockId && resolution.blockHash === candidate.blockHash)) {
            _context.n = 8;
            break;
          }
          return _context.a(2, receipt(proof, resolution.confirmations, resolution.reason, 'unchanged'));
        case 8:
          _context.n = 9;
          return runStorage.replaceCanonicalBlockEvidence(storage, dbname, _objectSpread(_objectSpread({}, candidate), {}, {
            blockId: resolution.blockId,
            blockHash: resolution.blockHash,
            observedAt: observedAt,
            expectedBlockId: candidate.blockId,
            expectedBlockHash: candidate.blockHash
          }));
        case 9:
          replaced = _context.v;
          if (!(replaced.status === 'observed')) {
            _context.n = 10;
            break;
          }
          return _context.a(2, receipt(observedProof(proof, resolution, observedAt), resolution.confirmations, resolution.reason, 'relinked'));
        case 10:
          if (!(replaced.status === 'stale' && attempt < 2)) {
            _context.n = 11;
            break;
          }
          return _context.a(2, resolveStoredReceipt(storage, dbname, blockchain, fingerprint, observedAt, attempt + 1));
        case 11:
          return _context.a(2, receipt(associatedProof(proof), 0, 'invalid', 'deferred'));
        case 12:
          if (!CONFIRMED_MISMATCH_REASONS.has(resolution.reason)) {
            _context.n = 15;
            break;
          }
          _context.n = 13;
          return runStorage.clearCanonicalBlockEvidence(storage, dbname, candidate);
        case 13:
          cleared = _context.v;
          if (!(cleared.status === 'stale' && attempt < 2)) {
            _context.n = 14;
            break;
          }
          return _context.a(2, resolveStoredReceipt(storage, dbname, blockchain, fingerprint, observedAt, attempt + 1));
        case 14:
          if (!(cleared.status === 'cleared' || cleared.status === 'missing')) {
            _context.n = 15;
            break;
          }
          return _context.a(2, receipt(associatedProof(proof), 0, resolution.reason, 'downgraded'));
        case 15:
          return _context.a(2, receipt(associatedProof(proof), 0, resolution.reason, 'deferred'));
      }
    }, _callee, null, [[4, 6]]);
  }));
  return _resolveStoredReceipt.apply(this, arguments);
}
function normalizeObservedAt(value) {
  return Number.isSafeInteger(value) && value >= 0 ? value : Date.now();
}
function recordCanonicalCallback(_x6, _x7, _x8, _x9, _x0) {
  return _recordCanonicalCallback.apply(this, arguments);
}
function _recordCanonicalCallback() {
  _recordCanonicalCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(storage, dbname, blockchain, block, candidate) {
    var attempt, incoming, existing, previous, written;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          attempt = 0;
        case 1:
          if (!(attempt < 3)) {
            _context2.n = 11;
            break;
          }
          _context2.n = 2;
          return resolveCanonicalCallback(blockchain, block, candidate);
        case 2:
          incoming = _context2.v;
          if (!(incoming.state !== 'observed')) {
            _context2.n = 3;
            break;
          }
          return _context2.a(2, incoming);
        case 3:
          _context2.n = 4;
          return resolveStoredReceipt(storage, dbname, blockchain, candidate.fingerprint, candidate.observedAt);
        case 4:
          existing = _context2.v;
          if (!(!existing || existing.proof.chain.transactionSignature !== candidate.transactionSignature)) {
            _context2.n = 5;
            break;
          }
          return _context2.a(2, Object.freeze({
            state: 'signed',
            reason: 'association_conflict'
          }));
        case 5:
          if (!(existing.action === 'deferred')) {
            _context2.n = 6;
            break;
          }
          return _context2.a(2, Object.freeze({
            state: 'signed',
            reason: existing.reason
          }));
        case 6:
          previous = existing.proof.chain.state === 'observed' ? existing.proof.chain.block : null;
          if (!(previous && previous.id <= incoming.blockId)) {
            _context2.n = 7;
            break;
          }
          return _context2.a(2, Object.freeze(_objectSpread(_objectSpread({}, incoming), {}, {
            blockId: previous.id,
            blockHash: previous.hash,
            confirmations: existing.confirmations,
            reason: 'retained'
          })));
        case 7:
          _context2.n = 8;
          return runStorage.replaceCanonicalBlockEvidence(storage, dbname, _objectSpread(_objectSpread({}, candidate), previous ? {
            expectedBlockId: previous.id,
            expectedBlockHash: previous.hash
          } : {
            onlyIfUnobserved: true
          }));
        case 8:
          written = _context2.v;
          if (!(written.status === 'observed')) {
            _context2.n = 9;
            break;
          }
          return _context2.a(2, incoming);
        case 9:
          if (!(written.status !== 'stale')) {
            _context2.n = 10;
            break;
          }
          return _context2.a(2, Object.freeze({
            state: 'signed',
            reason: 'association_conflict'
          }));
        case 10:
          attempt += 1;
          _context2.n = 1;
          break;
        case 11:
          return _context2.a(2, Object.freeze({
            state: 'signed',
            reason: 'concurrent_update'
          }));
      }
    }, _callee2);
  }));
  return _recordCanonicalCallback.apply(this, arguments);
}
function returnCanonicalRunProof(_x1, _x10, _x11, _x12, _x13) {
  return _returnCanonicalRunProof.apply(this, arguments);
}
function _returnCanonicalRunProof() {
  _returnCanonicalRunProof = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(storage, dbname, blockchain, fingerprint, now) {
    var result;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return resolveStoredReceipt(storage, dbname, blockchain, fingerprint, normalizeObservedAt(now));
        case 1:
          result = _context3.v;
          return _context3.a(2, result ? result.proof : null);
      }
    }, _callee3);
  }));
  return _returnCanonicalRunProof.apply(this, arguments);
}
function returnCanonicalAssociationStatus(_x14, _x15, _x16, _x17, _x18) {
  return _returnCanonicalAssociationStatus.apply(this, arguments);
}
function _returnCanonicalAssociationStatus() {
  _returnCanonicalAssociationStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(storage, dbname, blockchain, fingerprint, now) {
    var result, state, observed;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return resolveStoredReceipt(storage, dbname, blockchain, fingerprint, normalizeObservedAt(now));
        case 1:
          result = _context4.v;
          if (result) {
            _context4.n = 2;
            break;
          }
          return _context4.a(2, null);
        case 2:
          state = result.proof.chain.state;
          observed = state === 'observed';
          return _context4.a(2, Object.freeze({
            associated: state !== 'pending',
            state: state,
            blockId: observed ? result.proof.chain.block.id : null,
            confirmations: observed ? result.confirmations : 0,
            retentionComplete: observed && result.confirmations >= 6
          }));
      }
    }, _callee4);
  }));
  return _returnCanonicalAssociationStatus.apply(this, arguments);
}
function reconcileBlockEvidence(_x19, _x20, _x21, _x22) {
  return _reconcileBlockEvidence.apply(this, arguments);
}
function _reconcileBlockEvidence() {
  _reconcileBlockEvidence = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(storage, dbname, blockchain, now) {
    var observedAt, summary, afterFingerprint, complete, limit, candidates, _iterator, _step, candidate, result, _t2, _t3;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          observedAt = normalizeObservedAt(now);
          summary = {
            checked: 0,
            relinked: 0,
            downgraded: 0,
            deferred: 0
          };
          afterFingerprint = '';
          complete = false;
        case 1:
          if (!(summary.checked < MAX_RECONCILIATION_CANDIDATES)) {
            _context5.n = 16;
            break;
          }
          limit = Math.min(PAGE_SIZE, MAX_RECONCILIATION_CANDIDATES - summary.checked);
          _context5.n = 2;
          return runStorage.listBlockEvidenceCandidates(storage, dbname, {
            afterFingerprint: afterFingerprint,
            limit: limit
          });
        case 2:
          candidates = _context5.v;
          if (!(candidates.length === 0)) {
            _context5.n = 3;
            break;
          }
          complete = true;
          return _context5.a(3, 16);
        case 3:
          _iterator = _createForOfIteratorHelper(candidates);
          _context5.p = 4;
          _iterator.s();
        case 5:
          if ((_step = _iterator.n()).done) {
            _context5.n = 11;
            break;
          }
          candidate = _step.value;
          _context5.p = 6;
          _context5.n = 7;
          return resolveStoredReceipt(storage, dbname, blockchain, candidate.fingerprint, observedAt);
        case 7:
          result = _context5.v;
          if (result && result.action === 'relinked') summary.relinked += 1;
          if (result && result.action === 'downgraded') summary.downgraded += 1;
          if (!result || result.action === 'deferred') summary.deferred += 1;
          _context5.n = 9;
          break;
        case 8:
          _context5.p = 8;
          _t2 = _context5.v;
          summary.deferred += 1;
        case 9:
          summary.checked += 1;
        case 10:
          _context5.n = 5;
          break;
        case 11:
          _context5.n = 13;
          break;
        case 12:
          _context5.p = 12;
          _t3 = _context5.v;
          _iterator.e(_t3);
        case 13:
          _context5.p = 13;
          _iterator.f();
          return _context5.f(13);
        case 14:
          afterFingerprint = candidates[candidates.length - 1].fingerprint;
          if (!(candidates.length < limit)) {
            _context5.n = 15;
            break;
          }
          complete = true;
          return _context5.a(3, 16);
        case 15:
          _context5.n = 1;
          break;
        case 16:
          return _context5.a(2, Object.freeze(_objectSpread(_objectSpread({}, summary), {}, {
            complete: complete
          })));
      }
    }, _callee5, null, [[6, 8], [4, 12, 13, 14]]);
  }));
  return _reconcileBlockEvidence.apply(this, arguments);
}
function clearBlockEvidenceAt(_x23, _x24, _x25, _x26) {
  return _clearBlockEvidenceAt.apply(this, arguments);
}
function _clearBlockEvidenceAt() {
  _clearBlockEvidenceAt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(storage, dbname, blockId, blockHash) {
    var summary, afterFingerprint, complete, limit, candidates, _iterator2, _step2, candidate, result, _t4, _t5;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.p = _context6.n) {
        case 0:
          if (!(!Number.isSafeInteger(blockId) || blockId < 0 || typeof blockHash !== 'string' || !/^[a-f0-9]{64}$/.test(blockHash))) {
            _context6.n = 1;
            break;
          }
          throw new Error('Invalid block evidence removal.');
        case 1:
          summary = {
            checked: 0,
            matched: 0,
            cleared: 0,
            stale: 0
          };
          afterFingerprint = '';
          complete = false;
        case 2:
          if (!(summary.checked < MAX_RECONCILIATION_CANDIDATES)) {
            _context6.n = 17;
            break;
          }
          limit = Math.min(PAGE_SIZE, MAX_RECONCILIATION_CANDIDATES - summary.checked);
          _context6.n = 3;
          return runStorage.listBlockEvidenceCandidates(storage, dbname, {
            afterFingerprint: afterFingerprint,
            limit: limit
          });
        case 3:
          candidates = _context6.v;
          if (!(candidates.length === 0)) {
            _context6.n = 4;
            break;
          }
          complete = true;
          return _context6.a(3, 17);
        case 4:
          _iterator2 = _createForOfIteratorHelper(candidates);
          _context6.p = 5;
          _iterator2.s();
        case 6:
          if ((_step2 = _iterator2.n()).done) {
            _context6.n = 12;
            break;
          }
          candidate = _step2.value;
          summary.checked += 1;
          if (!(candidate.blockId !== blockId || candidate.blockHash !== blockHash)) {
            _context6.n = 7;
            break;
          }
          return _context6.a(3, 11);
        case 7:
          summary.matched += 1;
          _context6.p = 8;
          _context6.n = 9;
          return runStorage.clearCanonicalBlockEvidence(storage, dbname, candidate);
        case 9:
          result = _context6.v;
          if (result.status === 'cleared') summary.cleared += 1;else summary.stale += 1;
          _context6.n = 11;
          break;
        case 10:
          _context6.p = 10;
          _t4 = _context6.v;
          summary.stale += 1;
        case 11:
          _context6.n = 6;
          break;
        case 12:
          _context6.n = 14;
          break;
        case 13:
          _context6.p = 13;
          _t5 = _context6.v;
          _iterator2.e(_t5);
        case 14:
          _context6.p = 14;
          _iterator2.f();
          return _context6.f(14);
        case 15:
          afterFingerprint = candidates[candidates.length - 1].fingerprint;
          if (!(candidates.length < limit)) {
            _context6.n = 16;
            break;
          }
          complete = true;
          return _context6.a(3, 17);
        case 16:
          _context6.n = 2;
          break;
        case 17:
          return _context6.a(2, Object.freeze(_objectSpread(_objectSpread({}, summary), {}, {
            complete: complete
          })));
      }
    }, _callee6, null, [[8, 10], [5, 13, 14, 15]]);
  }));
  return _clearBlockEvidenceAt.apply(this, arguments);
}
module.exports = {
  recordCanonicalCallback: recordCanonicalCallback,
  clearBlockEvidenceAt: clearBlockEvidenceAt,
  reconcileBlockEvidence: reconcileBlockEvidence,
  resolveCanonicalCallback: resolveCanonicalCallback,
  returnCanonicalAssociationStatus: returnCanonicalAssociationStatus,
  returnCanonicalRunProof: returnCanonicalRunProof
};